export interface IPostPayment {
	affects_commission: boolean;
	affects_tbv: boolean;
	amount: number;
	booking?: string;
	created_at?: string;
	currency: string;
	direction: string;
	id?: number;
	target: string;
	taxable?: boolean;
	updated_at?: string;
	reason?: string;
}

export interface IPendingPostPayment {
	action: 'add' | 'remove';
	payment: IPostPayment;
	eventId: string;
}

export const collapsePending = (pending: IPendingPostPayment[]) => {
	let output: IPendingPostPayment[] = [];
	for (const item of pending) {
		if (item.action === 'add') {
			output.push(item);
		} else {
			const filtered = output.filter(
				(a) => !(a.eventId === item.eventId && a.action === 'add' && JSON.stringify(a.payment) === JSON.stringify(item.payment))
			);
			if (filtered.length !== output.length) {
				output = filtered;
			} else {
				output.push(item);
			}
		}
	}

	return output;
};

export const applyPending = (pendingPayments: IPendingPostPayment[], postPayments: IPostPayment[]) => {
	let output = [...postPayments];
	const flattenedPending = collapsePending(pendingPayments);

	for (const pending of flattenedPending) {
		if (pending.action === 'add') {
			output.push(pending.payment);
		} else {
			output = output.filter((a) => JSON.stringify(a) !== JSON.stringify(pending.payment));
		}
	}

	return output;
};
